import {
	Button,
	DataTable,
	DataTableColumn,
	Toast,
	ToastContainer
} from '@salesforce/design-system-react';
import RecordHome from 'lib/RecordHome';
import { Request } from 'lib/types';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

interface RequestHomeState {
	editing: boolean;
	toast: boolean;
}

interface RequestHomeProps {
	navBack: () => void;
	request: Request;
}

class RequestHome extends React.Component<RequestHomeProps, RequestHomeState> {
	private toasts: Element;

	constructor (props: RequestHomeProps) {
		super(props);
		this.state = {
			editing: false,
			toast: false
		};
	}

	editRequest = () => {
		this.setState({ editing: true });
	}

	saveRequest = () => {
		this.closeModal();
		const openToast = () => { this.toasts.className = this.toasts.className + ' open'; };
		const closeToast = () => this.toasts.className = this.toasts.className.replace(' open', '');
		this.setState({
			toast: true
		});
		setTimeout(() => { openToast(); setTimeout(closeToast, 2000); }, 0);
	}

	closeModal = () => {
		this.setState({ editing: false });
	}

	render () {
		const { navBack, request } = this.props;
		const title = (
			<span><img src="/assets/icons/service-circle.svg" width="16" style={{marginTop: '-4px'}} /> NTO North America</span>
		);

		const details = [
			{ label: 'Records', content: '2' },
			{ label: 'Requested By', content: request.requestor },
			{ label: 'Requested From', content: title},
			{ label: 'Priority', content: request.priority },
			{ label: 'Status', content: request.status },
			{ label: 'Note from Requestor', content: request.note || '' },
		];

		const tieBreakers = [
			{	id: '00330000011DhJj', name: 'Samantha Smith-Jones',
				email: (
					<div>
						<p><span className="slds-text-color_weak">Home: </span>ssmith@gmail.com</p>
						<p><span className="slds-text-color_weak">Work: </span>sam@mystyle.com</p>
					</div>
				), 
				phone: (
					<div>
						<p><span className="slds-text-color_weak">Home: </span>+14089313560</p>
						<p><span className="slds-text-color_weak">Mobile: </span>+15407531122</p>
						<p><span className="slds-text-color_weak">Work: </span>+442031477600</p>
						<p><span className="slds-text-color_weak">Other: </span>+4480072533333</p>
					</div>
				),
				address: (
					<div>
						<p><span className="slds-text-color_weak">Billing: </span>
							221B Baker St Marlyebone, London NW1 6TT, United Kingdom</p>
						<p><span className="slds-text-color_weak">Shipping: </span>
							1500 California Ave., Apt. 2, San Francisco CA, 94102</p>
					</div>
				)
			},
			{	id: '00330000011DdIo', name: 'Samantha Jones',
				email: (
					<div>
						<p><span className="slds-text-color_weak">Home: </span>s.smith@outlook.com</p>
					</div>
				), 
				phone: (
					<div>
						<p><span className="slds-text-color_weak">Home: </span>+14089313560</p>
					</div>
				)
			}
		];

		return (
			<div className="stewardship-profile">
				<ToastContainer ref={(toasts: React.ReactInstance) => this.toasts = ReactDOM.findDOMNode(toasts) as Element}>
					{this.state.toast ?
						<Toast	
							labels={{ heading: 'Last Updated was set as the data reconciliation rule.'}}
							variant="success"
						/> :
						null
					}
				</ToastContainer>
				<RecordHome
					buttons={[]}
					details={details}
					page={<a href="javascript:void(0);" onClick={navBack}>Profile Merge</a>}
					section={<a href="javascript:void(0);">Request Queue</a>}
					title={request.name}
				/>
				<div className="slds-box slds-m-top_small">
					<Button className="slds-float_right" label="Merge Records" />
					<p>The following records have been flagged for merge.</p>
					<DataTable items={tieBreakers}>
						<DataTableColumn label="ID" key="id" property="id" />
						<DataTableColumn label="Name" key="name" property="name" />
						<DataTableColumn label="Email" key="email" property="email" />
						<DataTableColumn label="Phone" key="phone" property="phone" />
						<DataTableColumn label="Address" key="address" property="address" truncate />
					</DataTable>
				</div>
			</div>
		);
	}
}

export default RequestHome;


// WEBPACK FOOTER //
// ./src/DataStewardship/request-home.tsx